import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { InvoicingService } from "./invoicing.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { LedgerLines, LedgerLine, InvoiceDocumentModel, InvoicesModel, Invoice } from "./invoicing";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { ApiEndPoints } from "../api.endpoints";
import { LoaderService } from "../LoaderService";
declare var $: any;


@Component({
    templateUrl: "./invoicingdetail.payments.component.html"
})
export class InvoicingDetailPaymentsComponent implements OnInit, AfterViewInit {
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject();
    public pageTitle: string = 'Invoicing';
    public invoiceName: string = 'payments';
    public activeAccountId: string = '';
    public accessAccounts: IAccount[];
    public processAccount: IAccount;
    public ledgerLines: LedgerLines;
    public invoicesList: Invoice[];
    constructor(
        private authService: AuthService,
        private appCommonService: AppCommonService,
        public invoicingService: InvoicingService,
        private route: ActivatedRoute,
        private router: Router,
        public headerAndNavigationService: HeaderAndNavigationService,
        public loaderService: LoaderService
    ) {
        this.appCommonService.pageContentAdditionalClass = "";
        this.appCommonService.pageName = this.pageTitle;
    }
    ngOnInit(): void {
        this.headerAndNavigationService.showhideNav(false, true);
        this.accessAccounts = this.authService.getSelectedAccessAccounts();
        //debugger
        this.processAccount = null;
        this.processAccount = this.accessAccounts[0];
        this.paymentsOnInit();
        this.datefilerInitiate();
        this.loadInvoicesList();
    }

    datefilerInitiate() {
        $(document).ready(function () {
            jQuery.extend($.fn.dataTableExt.oSort, {
                "date-uk-pre": function (a) {
                    if (a == null || a == "") {
                        return 0;
                    }
                    var ukDatea = a.split('-');
                    return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
                },

                "date-uk-asc": function (a, b) {
                    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
                },

                "date-uk-desc": function (a, b) {
                    return ((a < b) ? 1 : ((a > b) ? -1 : 0));
                }
            });
        });
    }

    paymentsOnInit(): void {
        this.loaderService.display(true);
        this.dtOptions = {
            dom: '<"top"fip<"clear">>rt<"bottom"ip<"clear">>',
            responsive: true,
            info: false,
            iDisplayLength: 15,
            order: [],
            //columnDefs: [{ width: 32, targets: 0 }, { orderable: false, targets: [0, 3] }, { bSearchable: false, targets: [0, 3] }, { type: 'date-uk', targets: [4] }],
            columnDefs: [{ width: 32, targets: 0 }, { bSearchable: false, targets: [0, 4] }],
            fixedColumns: true,
            buttons: [{}]
        }

        this.ledgerLines = new LedgerLines();
        this.ledgerLines.accountNumber = this.processAccount.name;
        this.ledgerLines.accountId = this.processAccount.id;
        this.ledgerLines.ledger = this.processAccount.ledger;
        this.activeAccountId = this.processAccount.id;
        this.loadPaymentsList();
    }

    loadPaymentsList() {
        this.invoicingService.getLedgerLinesByAccountId(this.processAccount.id)
            .subscribe(
                (ledgerLines: LedgerLines) => {
                    //debugger;
                    console.log(ledgerLines);
                    this.ledgerLines.ledgerLines = ledgerLines[0].ledgerLines;
                    this.ledgerLines.outstandingBalance = ledgerLines[0].outstandingBalance;
                    this.dtTrigger.next();
                    this.loaderService.display(false);
                },
                (error: any) => {
                    this.invoicingService.showError("Ledger Lines retrieval problem", <any>error)
                    this.loaderService.display(false);
                }
            );
    }

    ngAfterViewInit(): void {

    }

    onAccountTabClick(index: number) {
        this.processAccount = this.accessAccounts[index];
        this.paymentsOnInit();
    }

    DownloadInvoiceDocument(led: LedgerLine) {
        this.loaderService.display(true);
        var model: InvoiceDocumentModel = new InvoiceDocumentModel();
        //debugger
        var selectedAcc = this.accessAccounts.filter(x => x.name == led.accountNumber)[0];
        let invoice = this.invoicesList.filter(x => x.invoiceNumber == led.reference)[0];
        if (invoice != undefined) {
            if (invoice.filename != '' && invoice.filename != "") {
                model.InvoiceId = led.documentId;
                model.AccountId = selectedAcc.id;
                model.Token = this.authService.getToken().access_token;
                model.filename = invoice.filename;
                //model.EndPointURL = ApiEndPoints.InvoiceByFileNameEndPoint;
                model.EndPointURL = ApiEndPoints.InvoiceByFileNameEndPointNew;

                this.invoicingService.getInvoiceDocument(model);
                this.loaderService.display(false);
            }
            else {
                this.loaderService.display(false);
                alert("No file found");
            }
        }
        else {
            this.loaderService.display(false);
            alert("No Invoice found for this record");
        }


    }


    loadInvoicesList() {
        this.loaderService.display(true);
        var model: InvoicesModel = new InvoicesModel();
        model.AccountId = [];
        model.Token = this.authService.getToken().access_token;
        //model.EndPointURL = ApiEndPoints.InvoicesEndPoint;
        this.accessAccounts.forEach(item => {
            model.AccountId.push(item.id);
        });
        this.invoicingService.getInvoices(model)
            .subscribe(
                (invoices: Invoice[]) => {
                    //debugger
                    this.invoicesList = invoices;
                    setTimeout(() => {

                        this.loaderService.display(false);
                    }, 100);
                    //this.dtTrigger.next();
                    //this.loaderService.display(false);
                },
                (error: any) => {
                    this.loaderService.display(false);
                    this.invoicingService.showError("Invoices retrieval problem", <any>error)
                }
            );
    }
    //$(document).ready(function () {
    //  jQuery.extend($.fn.dataTableExt.oSort, {
    //    "extract-date-pre": function (value) {
    //      var date = $(value, 'span')[0].innerHTML;
    //      date = date.split('/');
    //      return Date.parse(date[1] + '/' + date[0] + '/' + date[2])
    //    },
    //    "extract-date-asc": function (a, b) {
    //      return ((a < b) ? -1 : ((a > b) ? 1 : 0));
    //    },
    //    "extract-date-desc": function (a, b) {
    //      return ((a < b) ? 1 : ((a > b) ? -1 : 0));
    //    }
    //  });
    //});
}



// WEBPACK FOOTER //
// ./src/app/invoicing/invoicingdetail.payments.component.ts